import { api } from "./customers"

export interface PermissionManagement {
    roleId:number
    moduleId: number
    module_name: string
    permissionId: number
    permission_name: string
}

export interface Module {
    id: number
    module_name: string
    active_status: number
}

export interface Permission {
    id: number
    permission_name: string
    active_status: number
}

type PermissionManagementsResponse = PermissionManagement[]
type ModulesResponse = Module[]
type PermissionsResponse = Permission[]

export const PermissionManagementApi = api.injectEndpoints({
    endpoints: (build) => ({
        getPermissionManagements: build.query<PermissionManagementsResponse, void>({
            query: (id) => `role_permission_relationbyrole_id/${id}`,
            transformResponse: (response: { data: PermissionManagementsResponse }, meta, arg) => response.data,
            providesTags: (result) =>
                result
                    ? [
                        ...result.map(({ roleId }) => ({ type: 'PermissionManagement' as const, roleId })),
                        { type: 'PermissionManagement', id: 'LIST' },
                    ]
                    : [{ type: 'PermissionManagement', id: 'LIST' }],
        }),
        getModules: build.query<ModulesResponse, void>({
            query: () => `modules_master`,
            transformResponse: (response: { data: ModulesResponse }, meta, arg) => response.data,
            providesTags: (result) =>
                result
                    ? [
                        ...result.map(({ id }) => ({ type: 'Modules' as const, id })),
                        { type: 'Modules', id: 'LIST' },
                    ]
                    : [{ type: 'Modules', id: 'LIST' }],
        }),
        getPermissions: build.query<PermissionsResponse, void>({
            query: () => `permission_master`,
            transformResponse: (response: { data: PermissionsResponse }, meta, arg) => response.data,
            providesTags: (result) =>
                result
                    ? [
                        ...result.map(({ id }) => ({ type: 'Permissions' as const, id })),
                        { type: 'Permissions', id: 'LIST' },
                    ]
                    : [{ type: 'Permissions', id: 'LIST' }],
        }),
        addPermissionManagement: build.mutation<PermissionManagement, Partial<PermissionManagement>>({
            query: (body) => ({
                url: `role_permission_relation`,
                method: 'POST',
                body,
            }),
            transformResponse: (response: { data: PermissionManagement }, meta, arg) => response.data,
            invalidatesTags: [{ type: 'PermissionManagement', id: 'LIST' }],
        }),
        deletePermissionManagement: build.mutation<PermissionManagement, Partial<PermissionManagement>>({
            query: (body) => ({
                url: `role_permission_relation`,
                method: 'DELETE',
                body,
            }),
            transformResponse: (response: { data: PermissionManagement }, meta, arg) => response.data,
            invalidatesTags: [{ type: 'PermissionManagement', id: 'LIST' }],
        }),
    }),
})

export const {
    useGetPermissionManagementsQuery,
    useGetModulesQuery,
    useGetPermissionsQuery,
    useAddPermissionManagementMutation,
    useDeletePermissionManagementMutation
} = PermissionManagementApi

